import { css, SerializedStyles } from '@emotion/react'
import Avatar from '@mui/material/Avatar'
import { colors } from '@global/constants'
import { User } from '@global/types'

export type UserPartial = Pick<User, 'avatar_slug' | 'name'>

interface Props {
  user: UserPartial | null
  size?: number
  compact?: boolean
  innerStyle?: object
  innerCss?: SerializedStyles
}

export const CvsAvatar = ({
  user,
  size = 30,
  compact = false,
  innerStyle = {},
  innerCss = css`
    font-size: 1rem;
    font-weight: bold;
    background-color: ${colors.blue.main};
  `,
}: Props) => {
  const name = user?.name || null
  const avatarSlug = user?.avatar_slug || null

  const alt = name
    ? name
        ?.split(' ')
        ?.map(part => part[0])
        ?.join('')
    : 'User Avatar'

  const style = {
    width: size,
    height: size,
    margin: compact ? '0 5px 0 0' : 5,
    ...innerStyle,
  }

  return (
    <Avatar
      alt={alt}
      src={avatarSlug ? `/api/v1/avatar/${avatarSlug}` : undefined}
      css={innerCss}
      style={style}
      data-testid="avatar"
    />
  )
}
